import Medcity from './medcity-logo.svg';
import Helthfarm from './helthfarm-logo.svg';
import Advertising from './megaphone.svg';
import Building from './office.svg';
import Car from './car.svg';
import Print from './cmyk.svg';
import Cinema from './film.svg';
import Lawyer from './briefcase.svg';
import Events from './balloons.svg';
import Food from './cutlery.svg';
import Globe from './globe.svg';
import Hotel from './architecture-and-city.svg';
import Beauty from './modern-haircut.svg';
import Orfos from './orfos-wo-name.svg';
import Renovation from './repair.svg';
import Protection from './rpg-game.svg';
import ShoppingBag from './shopping-basket.svg';
import Studying from './studying.svg';
import Drugstore from './hygieia.svg';
import Weightlifting from './dumbbell.svg';
import Smartphone from './smartphone.svg';
import Impulse from './impulse_small.png';
import Ocridge from './ocridge_small.png';
import Novigorod from './novigorod_small.png';
import Divo from './divo.png';
import Vinagro from './vinagro_small.png';
import SSSR from './cccp_small.png';
import Cinemadelux from './cinemadelux_small.png';
import Technolab from './technolab.png';
import Tele2 from './tele2.png';

export default {
	advertising:	{ svg: Advertising },
	building:	{ svg: Building },
	car:	{ svg: Car },
	print:	{ svg: Print },
	cinema:	{ svg: Cinema },
	lawyer:	{ svg: Lawyer },
	events:	{ svg: Events },
	food:	{ svg: Food },
	globe:	{ svg: Globe },
	hotel:	{ svg: Hotel },
	impulse:	{ png: Impulse },
	orfos:	{ svg: Orfos },
	ocridge:	{ png: Ocridge },
	novigorod:	{ png: Novigorod },
	divo:	{ png: Divo },
	healthfarm: { svg: Helthfarm },
	medcity:	{ svg: Medcity },
	beauty:	{ svg: Beauty },
	renovation:	{ svg: Renovation },
	vinagro:	{ png: Vinagro },
	SSSR:	{ png: SSSR },
	cinemadelux:	{ png: Cinemadelux },
	protection:	{ svg: Protection },
	shoppingbag:	{ svg: ShoppingBag },
	studying:	{ svg: Studying },
	drugstore:	{ svg: Drugstore },
	technolab:	{ png: Technolab },
	tele2:	{ png: Tele2 },
	weightlifting:	{ svg: Weightlifting },
	smartphone:	{ svg: Smartphone },
};
